/**
 * Returns true if the current URL has auth parameters for sign-in redirect.
 */
export function hasAuthParams() {
  // response_mode: query
  let searchParams = new URLSearchParams(window.location.search);

  if (searchParams.get("code") && searchParams.get("state")) {
    return true;
  }

  // response_mode: fragment
  searchParams = new URLSearchParams(window.location.hash.replace("#", "?"));

  if (searchParams.get("code") && searchParams.get("state")) {
    return true;
  }

  return false;
}
